
/**
 * @fileOverview EmailOptions module definition
 * @author a1rqlzz
 * @modified 09/23/2016
 **/

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('kungfu/EmailForm/EmailOptions',['require','jquery','validate','lib/Util','GlobalEventDispatcher','GlobalResizeListener'],function (require) {
        var $ = require('jquery'),
            subVal = require('validate'),
            emailInclude = require('lib/Util'),
            GlobalEventDispatcher = require('GlobalEventDispatcher'),
            GlobalResizeListener = require('GlobalResizeListener');

        require(['domReady!'], function (doc) {
            /*Fires upon DOM Ready to initialize component*/
            $debug('**** Email Set Up Started **** ', 'mmmEmail');
            $('.js-emailform').each(function (i, element) {
                $debug('Validate Block #' + (i + 1), 'mmmEmail');
                new EmailOptions($(element));
            });


        });
        $debug('Email form loaded - use ?debug=mmmEmail for messages', 'mmmEmail');

        /**
          * This sets up Subscribe Validation.
          *
          * @class ExpandContentView
          * @param {jQuery} $element A reference to the containing DOM element
          * @constructor
          */
        var EmailOptions = function ($element) {

            /**
             * A reference to the containing DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             */
            this.$element = $element;
            this.theme = '';

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @name isEnabled
             * @type bool
             */
            this.isEnabled = false;

            this.startnum = 0;

            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();

            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalResizeListener.getResizeListener()
             * @property GlobalResizeListener
             * @type {jQuery}
             */

            //this.globalResizeListener = GlobalResizeListener.getResizeListener();

            this.init(); //initialize component
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {ExpandContentView}
         * @private
         */
        EmailOptions.prototype.init = function () {
            this
                .setOptions()
                .createChildren()
                .setupHandlers()
                .enable()
                .build()
                .layout();

            if ($(".mix-MMM--hdg_spaced").filter(".MMM--bodyCopy").data("options")) {
                this.SwitchButtonControl();
            }

            //calling contactbaremail
            this.clickContactBarEmail();

            return this;
        };

        /**
         * This sets the options via data-options in the html markup. If
         * the options aren't set it goes to the defaults.
         *
         * @method setOptions
         * @returns {ExpandContentView}
         * @private
         */
        EmailOptions.prototype.setOptions = function () {
            var options = this.$element.data().options;
            var defaults = {
                enabled: true,
                debug: false,
                submitHandler: null,
                show_text: 'Show',
                hide_text: 'Hide'
            };
            this.settings = $.extend({}, defaults, options);
            $debug('     Block Options ', 'mmmSubValidate');
            $debug('          HTML data-options Settings: ' + $printObj(options), 'mmmEmail');
            $debug('          Default Settings: ' + $printObj(defaults), 'mmmEmail');
            $debug('          Combined Settings: ' + $printObj(this.settings), 'mmmEmail');
            $debug('          Rules Settings: ' + $printObj(this.settings.rules), 'mmmEmail');
            return this;
        };

        EmailOptions.prototype.createChildren = function () {
            //variables to hold objects for email link, form id, subject , optional fields grouped based on subject selection
            this.$container = this.$element.parent();
            this.$emailtrigger = $('.cc-08');
            this.$emaillnk = this.$element.find($('.MMM--Email-link'));
            this.$emaillnkIcn = this.$element.find($('.js-emailIcn'));
            this.$formId = this.$element.find($('input[name="form_id"]'));
            this.$formSubject = this.$element.find($('input[name="mail_subject"]'));
            this.SubjectLine = undefined;
            this.$emailcontainer = this.$element.find($('.MMM--Emailfield-container'));
            this.$fieldcontainer = this.$element.find($('.MMM--blockFormList'));
            this.$fancyDropdown = this.$fieldcontainer.find($(' .js-formoptions'));
            this.$defaultfields = this.$fieldcontainer.find($('.MMM--defaultFields'));
            this.$opt2fields = this.$fieldcontainer.find($('.MMM--Opt2Fields'));
            this.$opt3fields = this.$fieldcontainer.find($('.MMM--Opt3Fields'));
            this.$opt4fields = this.$fieldcontainer.find($('.MMM--Opt4Fields'));
            this.$hiddenfields = [];

            this.theme = SETTINGS.theme;

            //if (this.theme === undefined) {
            //    this.theme = 'unicorn';
            //}

            return this;
        };

        EmailOptions.prototype.enable = function () {
            var self = this,
                $scrollcontainer = self.$element.parents('.MMM--supportMod-content');
            $debug('in enable href : ' + window.location.href, 'mmmEmail');
            if (window.location.href.indexOf('cc-08=confirm') > 0) {
                this.$element.hide();
                this.$element.next().show();

                //update to remove trackJS error

                if ($scrollcontainer.length > 0) {
                    $('html, body').scrollTop($scrollcontainer.offset().top);
                }

                self.$element.next();

            }
            
            else if (window.location.href.indexOf('cc-08=true') > 0) {
                if (this.$emailcontainer.is(':visible')) {
                    this.$emailcontainer.slideUp(function () {
                        self.$emaillnk.html('');
                        self.$emaillnk.html(self.settings.show_text + '<i class="MMM--icn MMM--icn_arrowDown mix-MMM--icn_md mix-MMM--icn_dark"></i>');
                        self.$emaillnk.parent().removeClass('MMM--isActive');
                    });
                }
                else {
                    this.$emailcontainer.slideDown(function () {
                        self.$emaillnk.html('');
                        self.$emaillnk.html(self.settings.hide_text + '<i class="MMM--icn MMM--icn_arrowDown mix-MMM--icn_md mix-MMM--icn_dark"></i>');
                        self.$emaillnk.parent().addClass('MMM--isActive');
                    });
                }
                $('html, body').animate({ scrollTop: self.$element.offset().top }, 1000);
            }

            this.isEnabled = true;

            if (this.$element === undefined) {
                return this;
            }
            //enabling events for the select lists and email link
            var selectopts = this.$fancyDropdown, self = this;
            selectopts.on('change', function (event) {
                event.preventDefault();
                self.onChangeHandler($(this));
            });

            this.$emaillnk.on('click keydown', function (event) {
                if (event.which == 1 || event.which == 13){
                event.preventDefault();
                self.onClickHandler($(this));   
                }  
            });

            this.$emaillnkIcn.on('click keydown', function (event) {
                if (event.which == 1 || event.which == 13) {
                    event.preventDefault();
                    self.onClickHandler($(this));
                }
            });

            this.$emailtrigger.on('click', function (event) {
                //$debug('clicked', 'mmmEmail');
                event.preventDefault();
                self.onClickHandler($(this));
            });

            this.$fancyDropdown.parent().on('click', function (event) {
                event.preventDefault();
                self.onClickHandler($(this));
            });

            this.$fancyDropdown.parent().find($('.MMM--fancyDropAnchor')).on('focus', function (event) {
                $debug('**** Email, in enable on focus 1 **** ', 'mmmEmail');
                event.preventDefault();
                self.onFocusHandler($(this));
            });

            this.$fancyDropdown.parent().find($('.MMM--fancyDropAnchor')).on('blur', function (event) {
                $debug('**** Email, in enable on focus 2 **** ', 'mmmEmail');
                event.preventDefault();
                self.onBlurHandler($(this));
            });

            return this;
        };

        EmailOptions.prototype.disable = function () {
            $debug('*** In disable ***', 'mmmEmail');
            this.isEnabled = false;
            this.$fancyDropdown.parent().off('click', this.onClickHandler);   //remove click event for fancy select
            this.$fancyDropdown.parent().find($('.MMM--fancyDropAnchor')).off('focus', this.onFocusHandler);

            return this;
        };

        EmailOptions.prototype.layout = function () {
            $debug('Layout Change Fired  === ' + context, 'mmmEmail');
            if (this.$element === undefined) {
                return this;
            }

            return this;
        };

        EmailOptions.prototype.setupHandlers = function () {
            this.onClickHandler = this.onClick.bind(this);
            this.onChangeHandler = this.onChange.bind(this);
            this.onFocusHandler = this.onFocus.bind(this);
            this.onBlurHandler = this.onBlur.bind(this);

            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.layout.bind(this));
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.MODAL_OPEN, this.layout.bind(this));

            return this;
        };
        
        /**
         * Builds the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {ExpandContentView}
         * @public
         */
        EmailOptions.prototype.build = function () {
            $debug('In build', 'mmmEmail');
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = true;

            var self = this;

            var enabled = self.settings.enabled;

            var eleId = '#' + self.$element.attr('id');
            $debug('eleId: ' + eleId, 'mmmEmail');
           
            // jQuery validation .. customized for fancy box and error placement
            $(eleId).validate({


                rules: this.settings.rules,

                highlight: function (element, errorClass, validClass) {
                    $debug('in highlight elem class ' + $(element).attr('class') + ' msg ' + errorClass, 'mmmEmail');
                    $debug('highlight element: ' + element, 'mmmEmail');
                    $debug('highlight errorClass: ' + errorClass, 'mmmEmail');
                    $debug('highlight validClass: ' + validClass, 'mmmEmail');
                    if ($(element).attr('class').indexOf('js-fancyDropDown') !== -1) {
                        $(element).parent().find($('.MMM--fancyDropAnchor')).css({ 'border': '1px #ff0000 solid', 'color': '#ff0000' });
                    }
                    $(element).addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $debug('in un highlight elem class ' + $(element).attr('class') + ' msg ' + errorClass, 'mmmEmail');
                    $debug('un highlight element: ' + element, 'mmmEmail');
                    $debug('un highlight errorClass: ' + errorClass, 'mmmEmail');
                    $debug('un highlight validClass: ' + validClass, 'mmmEmail');
                    $(element).removeClass(errorClass).addClass(validClass);
                    if ($(element).attr('name').indexOf('subject') !== -1) {
                        $(element).parent().find($('.MMM--fancyDropAnchor')).css({ 'border': '1px solid #e5e4e4', 'color': '#000000' });
                    }
                },
                errorPlacement: function (error, element) {
                    $debug('in errorPlacement ' + $(element).attr('class') + ' msg ' + error, 'mmmEmail');
                    if ($(element).parent().hasClass('js-fancyDropDiv') && (!$(element).parent().parent().hasClass('MMM--Opt2Fields'))) {
                        error.insertAfter($(element).parent().parent().parent().parent());
                        $debug('1', 'mmmEmail');
                    }
                    else if ($(element).parent().hasClass('MMM--Opt2Fields') || $(element).parent().hasClass('MMM--Opt3Fields') || $(element).parent().hasClass('MMM--Opt4Fields')) {
                        error.insertAfter($(element).parent().parent());
                        $debug('2', 'mmmEmail');
                    }
                    else if (($(element).parent().hasClass('js-fancyDropDiv')) && ($(element).parent().parent().hasClass('MMM--Opt2Fields'))) {
                        error.insertAfter($(element).parent().parent().parent());
                        $debug('3', 'mmmEmail');
                    }
                    else {
                        error.insertAfter($(element).parent());
                        $debug('4' + eleId, 'mmmEmail');
                    }

                },
                submitHandler: function (form) {
                    $debug('submitHandler = ' + typeof self.settings.submitHandler, 'mmmEmail');
                    $debug('email = ' + $('#Email', 'mmmEmail'));
                    //setting the form Id and Subject from the settings object
                    self.$formId.val(self.settings.form_id);
                    self.$formSubject.val(self.SubjectLine);
                    //removing hidden fields so that they aren't submitted
                    for (var i = 0; i <= self.$hiddenfields.length; i++) {
                        $(self.$hiddenfields[i]).remove();
                    }

                    if (typeof self.settings.submitHandler === 'string') {
                        $debug('custom submit value present -- firing ' + self.settings.submitHandler, 'mmmEmail');

                        window[self.settings.submitHandler](form);
                    }
                    else {
                        $debug('no custom submit present -- submitting form', 'mmmEmail');
                        form.submit();
                    }
                },
                debug: self.settings.debug
            });

            if (self.$emaillnk.parent().hasClass('MMM--isActive')) {
                self.$emaillnk.attr('aria-expanded', 'true');

            } else{
                self.$emaillnk.attr('aria-expanded', 'false');

            }
                self.$emaillnk.attr('role', 'button');
                self.$emaillnk.attr('tabindex', '0');
                
            return this;
        };

        EmailOptions.prototype.SwitchButtonControl = function () {
            var self = this;
            var sBtn = $(".mix-MMM--hdg_spaced").filter(".MMM--bodyCopy").data("options").switchForm;

            if (sBtn === "No" || !sBtn)   // hide form by default       

            {
                self.$emaillnk.html('');
                if (self.theme === 'unicorn') {
                    self.$emaillnk.html(self.settings.show_text);
                    self.$emaillnkIcn.html('<i class="MMM--icn MMM--icn_arrowDown mix-MMM--icn_md mix-MMM--icn_dark"></i>');

                } else {
                    self.$emaillnk.html(self.settings.show_text + '<i class="MMM--icn MMM--icn_arrowDown mix-MMM--icn_md mix-MMM--icn_dark"></i>');
                }
                self.$emaillnk.attr('role', 'button');
                self.$emaillnk.attr('aria-expanded', 'false');
                self.$emaillnk.attr('tabindex', '0');
            }

            else {

                self.$emaillnk.html('');
                if (self.theme === 'unicorn') {
                    self.$emaillnk.html(self.settings.hide_text);
                    self.$emaillnkIcn.html('<i class="MMM--icn MMM--icn_arrowDown mix-MMM--icn_md mix-MMM--icn_dark"></i>');

                } else {
                    self.$emaillnk.html(self.settings.hide_text + '<i class="MMM--icn MMM--icn_arrowDown mix-MMM--icn_md mix-MMM--icn_dark"></i>');
                }
                self.$emaillnk.attr('role', 'button');
                self.$emaillnk.attr('aria-expanded', 'true');
                self.$emaillnk.attr('tabindex', '0');
                self.$emaillnk.parent().addClass('MMM--isActive');
                self.$emailcontainer.show();
            }
        }

        EmailOptions.prototype.onClick = function (target) {
            // click event to toggle email link
            var self = this;
            $debug('target ' + $(target).attr('class') + ' theme ' + self.theme, 'mmmEmail');
            if ($(target).hasClass('MMM--Email-link') || $(target).hasClass('js-emailIcn')) {
                if (this.$emailcontainer.is(':visible')) {
                    this.$emailcontainer.slideUp(function () {
                        self.$emaillnk.html('');
                        if ((self.theme !== undefined) && (self.theme === 'unicorn')) {
                            self.$emaillnk.html(self.settings.show_text);
                            //self.$emaillnkIcn.html('<i class="MMM--icn MMM--icn_arrowDown mix-MMM--icn_md mix-MMM--icn_dark"></i>');
                        } else {
                            self.$emaillnk.html(self.settings.show_text + '<i class="MMM--icn MMM--icn_arrowDown mix-MMM--icn_md mix-MMM--icn_dark"></i>');
                        }
                        $(target).addClass("js-formHidden");
                        $(target).parent().removeClass('MMM--isActive');
                        $(target).attr('aria-expanded', 'false');     
                    });
                }
                else {
                    this.$emailcontainer.slideDown(function () {
                        self.$emaillnk.html('');
                        if (self.theme === 'unicorn') {
                            self.$emaillnk.html(self.settings.hide_text);
                            //self.$emaillnkIcn.html('<i class="MMM--icn MMM--icn_arrowDown mix-MMM--icn_md mix-MMM--icn_dark"></i>');
                        } else {
                            self.$emaillnk.html(self.settings.hide_text + '<i class="MMM--icn MMM--icn_arrowDown mix-MMM--icn_md mix-MMM--icn_dark"></i>');
                        }
                        $(target).removeClass("js-formHidden");
                        $(target).parent().addClass('MMM--isActive');
                        $(target).attr('aria-expanded', 'true');
                    });
                }
            }
            else if ($(target).hasClass('cc-08')) {
                self.$emaillnk.html('');
                this.$emailcontainer.slideDown(function () {
                    self.$emaillnk.html(self.settings.hide_text);
                    self.$emaillnk.parent().addClass('MMM--isActive');
                });
                $('html, body').animate({ scrollTop: self.$element.offset().top }, 1000);
            }

            return false;
        };

        EmailOptions.prototype.onFocus = function (target) {
            $debug('**** Email, in focus 1 **** ', 'mmmEmail');
            if (!(this.$fancyDropdown.hasClass('error'))) {
                $(target).parent().find($('.MMM--fancyDropAnchor')).css({ 'border': '1px solid #000000' });
            }
        };

        EmailOptions.prototype.onBlur = function (target) {
            $debug('**** Email, in focus 2 **** ', 'mmmEmail');
            if (!(this.$fancyDropdown.hasClass('error'))) {
                $(target).parent().find($('.MMM--fancyDropAnchor')).css({ 'border': '1px solid #ffffff' });
            }
        };

        EmailOptions.prototype.onChange = function (target) {
            // change event for Subject fancy select box
            var self = this;

            this.$hiddenfields = [];

            this.$fancyDropdown.removeClass('error');
            this.$fancyDropdown.parent().parent().find($('.error')).remove();
            $(target).parent().find($('.MMM--fancyDropAnchor')).css({ 'border': '1px solid #e5e4e4', 'color': '#000000' });
            $(target).parent().find($('.error')).remove();

            // populating select list with the selected attribute and the Subjectline variable with the actual text value of the subject drop down
            $('#' + $(target).attr('id')).val($(target).val());
            self.SubjectLine = $('#' + $(target).attr('id') + ' option:selected').text();
            /*$('#'+ $(target).attr('id') +' option').each(function(i){
                if ($(this).val() === $(target).val()) {
                    $('#'+ $(target).attr('id') +' option[value='+$(this).val()+']' ).attr('selected', 'selected');
                    self.SubjectLine = $('#'+ $(target).attr('id') +' option[value='+$(this).val()+']' ).text();
                }
                else {
                    $('#'+ $(target).attr('id') +' option[value='+$(this).val()+']' ).attr('selected', false);
 
                }
            });*/

            if ($(target).val() === '' || $(target).val() === '1' || $(target).val() === '2' || $(target).val() === '3' || $(target).val() === '6' || $(target).val() === '8' || $(target).val() === '10') {

                this.$opt2fields.each(function (e) {
                    $(this).slideUp();
                    self.$hiddenfields.push($(this));
                });
                this.$opt3fields.each(function (e) {
                    $(this).slideUp();
                    self.$hiddenfields.push($(this));
                });
            }
            else {
                if ($(target).val() === '4') {

                    this.$opt2fields.each(function (e) {
                        $(this).slideUp();
                        self.$hiddenfields.push($(this));
                    });
                    this.$opt3fields.each(function (e) {
                        $(this).slideUp();
                        self.$hiddenfields.push($(this));
                    });
                }
                else if ($(target).val() === '5') {

                    this.$opt2fields.each(function (e) {
                        $(this).slideUp();
                        self.$hiddenfields.push($(this));
                    });
                    this.$opt3fields.each(function (e) {
                        $(this).slideDown();
                    });
                }
                else if ($(target).val() === '7') {

                    this.$opt2fields.each(function (e) {
                        $(this).slideDown();
                        self.$hiddenfields.push($(this));
                    });
                    this.$opt3fields.each(function (e) {
                        $(this).slideDown();

                    });
                }
                else if ($(target).val() === '9') {

                    this.$opt2fields.each(function (e) {
                        $(this).slideUp();
                        self.$hiddenfields.push($(this));
                    });
                    this.$opt3fields.each(function (e) {
                        $(this).slideDown();
                    });
                    this.$opt4fields.each(function (e) {
                        $(this).slideDown();
                    });
                }
            }

            //clearing the hidden fields so that they aren't submitted
            for (var i = 0; i <= self.$hiddenfields.length; i++) {
                $(self.$hiddenfields[i]).children('input').val('');
            }

            this.clearErrors();
            return false;

        };

        EmailOptions.prototype.clearErrors = function (target) {
            if (this.$defaultfields.hasClass('error')) {
                this.$defaultfields.removeClass('error');
                this.$defaultfields.each(function (elem) {
                    if ($(this).parent().next('.error')) {
                        $(this).parent().next('.error').remove();
                    }
                });
            }

            if (this.$opt2fields.children('.error')) {
                this.$opt2fields.each(function (elem) {

                    if ($(this).hasClass('selectContainer')) {
                        $(this).find($('.MMM--fancyDropAnchor')).css({ 'border': '1px solid #e5e4e4', 'color': '#000000' });
                    }
                    if ($(this).children('.error')) {
                        $(this).children('.error').removeClass('error');
                    }
                    if ($(this).parent().next('.error')) {
                        $(this).parent().next('.error').remove();
                    }
                });
            }
            if (this.$opt3fields.children('.error')) {
                this.$opt3fields.each(function (elem) {
                    if ($(this).children('.error')) {
                        $(this).children('.error').removeClass('error');
                    }
                    if ($(this).parent().next('.error')) {
                        $(this).parent().next('.error').remove();
                    }
                });
            }
            if (this.$opt4fields.children('.error')) {
                this.$opt4fields.each(function (elem) {
                    if ($(this).children('.error')) {
                        $(this).children('.error').removeClass('error');
                    }
                    if ($(this).parent().next('.error')) {
                        $(this).parent().next('.error').remove();
                    }
                });
            }

            this.$fancyDropdown.each(function (elem) {
                //$debug('fancyDropdown ' + $(this).attr('class'), 'mmmEmail');

                if ($(this).parent().parent().parent().parent().next('.error')) {
                    $(this).parent().parent().parent().parent().next('.error').remove();
                }
            });
            return false;
        };

        EmailOptions.prototype.clickContactBarEmail = function () {
            
            //ONLY for conatctBar Email Content
            var contactTrig = $('.js-EmailFormToggle-trigger'),
                contactTarg = $('.js-EmailFormToggle-target');

            if (contactTrig.length > 0 && contactTarg.length > 0) {
                $debug('Email form clickContactBarEmail loaded', 'mmmEmail');

                contactTrig.off('click').on('click', function (event) {
                    var $this = $(event.currentTarget),
                        tDiv = $(event.currentTarget).parent().parent().parent().find($('.js-EmailFormToggle-target'));

                    event.preventDefault();
                    tDiv.slideDown(500, function () {
                        //add active class to contactTarg
                        tDiv.addClass('MMM--isActive');

                        if ($this.hasClass('MMM--isActive')) {
                            $debug('clickContactBarEmail found Active class removing it 2', 'mmmEmail');

                            // already been clicked once, hide it
                            tDiv.slideUp(250, function () {
                                tDiv.removeClass('MMM--isActive').removeAttr('style');
                            });
                            
                            //remove class to close drawer
                            $this.removeClass('MMM--isActive');
                            
                        } else {
                            // first time this is clicked, mark it
                            $this.addClass('MMM--isActive');
                            $debug('clickContactBarEmail added Active class 1', 'mmmEmail');

                            $('html,body').animate({
                                scrollTop: tDiv.offset().top - 10
                            });
                        }
                    });

                });
            }

        }

        return EmailOptions;
    });


}(MMMRequire));
